export const articles = [
    {
        slug: "choosing-your-first-dairy-cow",
        chapter: "01",
        title: "Choosing Your First Dairy Cow",
        excerpt: "The single most important decision a new dairy farmer makes. A framework for matching breed to climate, market and management capacity.",
        image: "/generated/gir.jpg",
        readTime: "8 min read",
        category: "Getting Started",
    },
    {
        slug: "understanding-milk-fat",
        chapter: "02",
        title: "Understanding Milk Fat",
        excerpt: "Why 5% fat cows can be more profitable than 30-litre cows — a plain explanation of SNF, protein and milk pricing.",
        image: "/generated/jersey.jpg",
        readTime: "6 min read",
        category: "Economics",
    },
    {
        slug: "feed-economics",
        chapter: "03",
        title: "Feed Economics",
        excerpt: "Feed is 65% of your cost. Learn the concentrate-to-fodder ratio that keeps profits healthy through every season.",
        image: "/generated/about.jpg",
        readTime: "10 min read",
        category: "Economics",
    },
    {
        slug: "daily-operating-costs",
        chapter: "04",
        title: "How Much Does One Dairy Cow Really Cost Per Day?",
        excerpt: "A transparent breakdown of feed, labour, electricity, veterinary and depreciation — the numbers most farmers never calculate.",
        image: "/generated/hf.jpg",
        readTime: "12 min read",
        category: "Economics",
        featured: true,
    },
    {
        slug: "dairy-shed-design",
        chapter: "05",
        title: "Dairy Shed Design",
        excerpt: "Ventilation, floor slope, drainage and orientation — the shed you build today decides your yield for the next fifteen years.",
        image: "/generated/hallikar.jpg",
        readTime: "9 min read",
        category: "Infrastructure",
    },
    {
        slug: "vaccination-schedule",
        chapter: "06",
        title: "Vaccination Schedule",
        excerpt: "FMD, HS, BQ, Brucellosis — the calendar every Karnataka farmer should follow, from calf to adult.",
        image: "/generated/calf_only.jpg",
        readTime: "7 min read",
        category: "Health",
    },
    {
        slug: "milking-hygiene",
        chapter: "07",
        title: "Milking Hygiene",
        excerpt: "Clean milking is the difference between premium and rejected milk. A step-by-step protocol proven in Karnataka co-operatives.",
        image: "/generated/black.jpg",
        readTime: "5 min read",
        category: "Operations",
    },
    {
        slug: "heat-stress-management",
        chapter: "08",
        title: "Heat Stress Management",
        excerpt: "Karnataka summers can drop yields by 30%. Simple, low-cost cooling strategies that protect production year-round.",
        image: "/generated/kankrej.jpg",
        readTime: "8 min read",
        category: "Operations",
    },
    {
        slug: "common-beginner-mistakes",
        chapter: "09",
        title: "Common Beginner Mistakes",
        excerpt: "Twelve costly errors we see every month in new dairy farms — and how each of them could have been avoided.",
        image: "/generated/feature.jpg",
        readTime: "11 min read",
        category: "Getting Started",
    },
    {
        slug: "profitability-planning",
        chapter: "10",
        title: "Profitability Planning",
        excerpt: "A ten-cow farm income-and-expense model — plus the four levers that separate profitable dairies from struggling ones.",
        image: "/generated/hero.jpg",
        readTime: "13 min read",
        category: "Economics",
    },
];

export const learningTopics = [
    { title: "Daily Milk Production", body: "Understand realistic per-cow yields across breeds and seasons." },
    { title: "Milk Fat Percentage", body: "Why fat and SNF drive pricing more than volume." },
    { title: "Purchase Cost", body: "Calf, heifer, first-calving and lactating price ranges." },
    { title: "Feed Requirements", body: "Green fodder, dry fodder, concentrate, minerals and water." },
    { title: "Feed Cost", body: "Daily, monthly and yearly feeding cost per animal." },
    { title: "Labour Requirement", body: "Man-hours required per cow per day for a healthy operation." },
    { title: "Housing", body: "Covered and open area, ventilation, flooring and drainage." },
    { title: "Health", body: "Disease resistance, heat stress and veterinary care." },
    { title: "Breeding", body: "First calving age, gestation, calving interval and AI." },
    { title: "Profitability", body: "How to calculate honest ROI before you invest." },
    { title: "ROI Planning", body: "Break-even months and long-term cash flow modeling." },
];
